module.exports = {
      id: "car-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#car",
      toString: function () {
        return this.url;
      }
    }